import { __extends } from "tslib";
import React from 'react';
import classnames from 'classnames';
import ddt from '@wix/da-ddt';
import s from './ErrorBoundary.scss';
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorBoundary.getDerivedStateFromError = function () {
        return { isError: true };
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        if (process.env.NODE_ENV === 'development' &&
            errorInfo &&
            errorInfo.componentStack) {
            // eslint-disable-next-line no-console
            console.error(errorInfo.componentStack); // tslint:disable-line
        }
        if (window && window.Sentry) {
            window.Sentry.captureException(error);
        }
        ddt.alert('fatal', "Error Boundary Caught: " + ((error && error.message) || 'unknown'), ['fatal'], {
            stacktrace: error && error.stack,
        });
        if (process.env.NODE_ENV === 'test') {
            throw error;
        }
    };
    ErrorBoundary.prototype.render = function () {
        if (this.state && this.state.isError) {
            if (this.props.hideOnFail) {
                return null;
            }
            return (React.createElement("div", { className: classnames(s['error'], this.props.className), style: this.props.style },
                this.props.humanError && React.createElement("p", null, this.props.humanError),
                !this.props.humanError && (React.createElement(React.Fragment, null,
                    React.createElement("p", null, "Something went wrong on our end. Please try again or reload the page."),
                    React.createElement("p", null, "Guru Meditation, llama on fire...")))));
        }
        return this.props.children;
    };
    return ErrorBoundary;
}(React.Component));
export default ErrorBoundary;
//# sourceMappingURL=ErrorBoundary.js.map